import React from 'react';
  
  const Index = () =>  {
	return (
	  <div>
	  </div>
	);
  }
  
  export default Index;
  export { default as NestedObjects } from './NestedObjects'